export default __webpack_public_path__ + "static/media/arrow-back.8d2f673b.svg";